export default function shuffleArray<T>(array: Array<T>): Array<T> {
	const copy = [...array];
	let currentIndex = copy.length;

	// While there remain elements to shuffle...
	while (currentIndex !== 0) {
		// Pick a remaining element...
		let randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex--;

		// And swap it with the current element.
		[copy[currentIndex], copy[randomIndex]] = [copy[randomIndex], copy[currentIndex]];
	}

	return copy;
}
